module.exports = __webpack_public_path__ + "static/storyprocess-9cf5548970498447cad0df5b3cd74de4.jpg";